import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// React Router ne touche pas au défilement : en changeant de page, le
// navigateur reste à la hauteur où l'on était. Un clic sur un lien du pied de
// page chargeait donc la nouvelle page tout en laissant l'écran... sur le pied
// de page, en donnant l'impression que le clic n'avait rien fait.
//
// useLayoutEffect plutôt que useEffect : le défilement est appliqué avant
// l'affichage, sans laisser voir un instant l'ancienne position.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const typeNavigation = useNavigationType();

  useLayoutEffect(() => {
    // POP = bouton précédent/suivant du navigateur. On laisse alors le
    // navigateur restaurer lui-même la position : revenir en arrière doit
    // ramener le visiteur là où il avait laissé la page, pas tout en haut.
    if (typeNavigation === 'POP') return;

    // Lien vers une ancre : on vise l'élément visé plutôt que le haut de page.
    if (hash) {
      const cible = document.getElementById(hash.slice(1));
      if (cible) {
        cible.scrollIntoView();
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // La hauteur du document change encore juste après le montage (images,
    // blocs animés à l'entrée), ce qui laissait le défilement à quelques
    // dizaines de pixels du haut. On repasse à la frame suivante, une fois la
    // mise en page stabilisée. Le délai est d'environ 16 ms : trop court pour
    // contrarier un visiteur qui ferait défiler la page lui-même.
    const frame = requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, hash, typeNavigation]);

  return null;
}
